import {
  NJModal,
  NJModalContent,
  NJButton,
  NJSelectRoot as NJSelectInput,
  NJSelectItem,
  NJToastService,
} from "@engie-group/fluid-design-system-react";
import { ChunkingStrategy } from "../model";
import { useRef, useState } from "react";
import styles from "./fileModal.module.css";
import { fetchChunkingStrategies } from "./fetchChunkingStrategies";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchFileTypes } from "./fetchFileTypes";

export const FileModal = ({
  onSubmit,
  onClose,
}: {
  onSubmit: (file: File, chunkingStrategy: string) => void;
  onClose: () => void;
}) => {
  const { data: fileTypes } = useQuery({
    queryKey: ["file-types"],
    queryFn: fetchFileTypes,
  });
  const [chunkingStrategies, setChunkingStrategies] =
    useState<ChunkingStrategy[]>();
  const { mutate } = useMutation({
    mutationFn: async (file: File) => {
      return fetchChunkingStrategies(file.type);
    },
    onSuccess: (chunkingStrategies: ChunkingStrategy[]) => {
      setChunkingStrategies(chunkingStrategies);
      setChunking(chunkingStrategies?.[0]);
    },
    onError: (error) => {
      NJToastService(
        `Une erreur est survenue lors du chargement des stratégies de chunking : ${error.message}`,
      );
    },
  });
  const [file, setFile] = useState<File>();
  const [chunking, setChunking] = useState<ChunkingStrategy>();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <NJModal
      isOpen={true}
    >
      <NJModalContent
        onClose={onClose}
        id={"file-upload-modal"}
        footer={<NJButton
          label="Envoyer"
          onClick={() => {
            if (!file || !chunking) return;
            onSubmit(file, chunking);
          }}
        ></NJButton>}
      >


      <div className={styles["file-upload-modal"]}>
        <NJButton
          label={file ? file.name : "Choisir un fichier"}
          onClick={() => inputRef.current?.click()}
        ></NJButton>
        {file ? (
          <NJSelectInput
            buttonDefaultValueLabel="Choisir une stratégie de chunking"
            id="chunking_strategy"
            label="Stratégie de chunking"
            listNavigationLabel="Choisir une stratégie de chunking"
            value={chunking}
            onChange={(newValue) => setChunking(newValue as ChunkingStrategy)}
          >
            {chunkingStrategies?.map((strategy) => (
              <NJSelectItem key={crypto.randomUUID()} value={strategy}>
                {strategy}
              </NJSelectItem>
            )) || <></>}
          </NJSelectInput>
        ) : null}

        <input
          hidden
          type="file"
          ref={inputRef}
          accept={fileTypes?.join(",")}
          onChange={async (event) => {
            const newFile = event.target.files?.[0];
            if (!newFile) return;
            mutate(newFile);
            setFile(newFile);
          }}
        />
      </div>
    </NJModalContent>
    </NJModal>
  );
};
